import { FolderOverviewFeatureState, FolderOverviewState } from '../models'

import { FolderTrafficStatus } from '../models/folder-traffic-status.interface'
import { FolderVersion } from '@app/core/model/folder-version.model'
import { ScopeVersion } from '@app/core/model/scope-version'
import { SowRetainedHoursStats } from '@app/features/scope-overview/model/sow-retained-hours-stats.model'
import { createSelector } from '@ngrx/store'
import { getFolderOverviewFeatureState } from '../reducers'

const selectFolderOverviewFeatureState = createSelector(
  getFolderOverviewFeatureState,
  (state: FolderOverviewFeatureState): FolderOverviewState => state.folderOverview
)

const selectIsLoading = createSelector(
  selectFolderOverviewFeatureState,
  (state: FolderOverviewState): boolean => state?.isLoading
)

const selectFolder = createSelector(
  selectFolderOverviewFeatureState,
  (state: FolderOverviewState): FolderVersion => state?.folder
)

const selectScopes = createSelector(
  selectFolderOverviewFeatureState,
  (state: FolderOverviewState): ScopeVersion[] => state?.folderScopes
)

const selectRetainedHoursStats = createSelector(
  selectFolderOverviewFeatureState,
  (state: FolderOverviewState): SowRetainedHoursStats => state?.retainedHoursStats
)

const selectTrafficStatus = createSelector(
  selectFolderOverviewFeatureState,
  (state: FolderOverviewState): FolderTrafficStatus => state?.trafficStatus
)

export const FolderOverviewSelectors = {
  selectFolder,
  selectScopes,
  selectRetainedHoursStats,
  selectIsLoading,
  selectTrafficStatus,
}
